<template>
  <div class='h-dialogContainer h-alarm-filter'>
    <div class='row h-row-around-inputBox'>
      <div class='col-sm-6'>
        <div class='h-col-inputBox'>
          <div class='h-borderBox h-filterTopoTree height-464'>
            <ejs-grid ref="listNe" :dataSource='listdata'>
              <e-columns>
                <e-column field='text' :headerText='$t("Software.td_neID")' width='15%' clipMode='EllipsisWithTooltip'></e-column>
              </e-columns>
            </ejs-grid>
          </div>
        </div>
      </div>
      <div class='col-sm-6'>
        <div class='h-col-inputBox'>
          <div class='h-inputLit'>{{this.$t('MCS.taskName')}}:</div>
          <input class="e-input" type="text" v-model="taskName" maxlength="20"/>
        </div>
        <div class='h-col-inputBox'>
          <div class='h-inputLit'>{{this.$t('MCS.importType')}}:</div>
          <ejs-dropdownlist ref='importType' :enabled='false' :change="changeForImportType" id='importType' :dataSource='dataSourceOfImportType' :fields='fieldsOfImportType' v-model='importType'></ejs-dropdownlist>
        </div>
        <div class='h-col-inputBox'>
          <div class='h-inputLit'>{{this.$t('MCS.isCover')}}:</div>
          <div class='row'>
            <div class='col-sm-3 nopadding'>
              <ejs-radiobutton :label='$t("MCS.cover")' name='isCover' value='1' :checked='true' :change='coverChange'></ejs-radiobutton>
            </div>
            <div class='col-sm-3 nopadding' style='padding-left: 15px'>
              <ejs-radiobutton :label='$t("MCS.skip")' name='isCover' value='0'  :change='coverChange'></ejs-radiobutton>
            </div>
          </div>
        </div>
        <div class='h-col-inputBox' v-show="isShowBlackList">
          <div class='h-inputLit'>{{this.$t('MCS.blackListDealType')}}:</div>
          <div class='row'>
            <div class='col-sm-3 nopadding'>
              <ejs-radiobutton :label='$t("MCS.append")' name='blackList' value='0' :checked='true' :change='blackListChange'></ejs-radiobutton>
            </div>
            <div class='col-sm-3 nopadding' style='padding-left: 15px'>
              <ejs-radiobutton :label='$t("MCS.cover")' name='blackList' value='1'  :change='blackListChange'></ejs-radiobutton>
            </div>
          </div>
        </div>
        <div class='h-col-inputBox' v-show="isShowRelations">
          <div class='h-inputLit'>{{this.$t('MCS.groupMemberDealType')}}:</div>
          <div class='row'>
            <div class='col-sm-3 nopadding'>
              <ejs-radiobutton :label='$t("MCS.append")' name='relations' value='0' :checked='true' :change='relationsChange'></ejs-radiobutton>
            </div>
            <div class='col-sm-3 nopadding' style='padding-left: 15px'>
              <ejs-radiobutton :label='$t("MCS.cover")' name='relations' value='1'  :change='relationsChange'></ejs-radiobutton>
            </div>
          </div>
        </div>
        <div class='h-col-inputBox' v-show="isShowAreas">
          <div class='h-inputLit'>{{this.$t('MCS.groupAreaDealType')}}:</div>
          <div class='row'>
            <div class='col-sm-3 nopadding'>
              <ejs-radiobutton :label='$t("MCS.append")' name='areas' value='0' :checked='true' :change='areasChange'></ejs-radiobutton>
            </div>
            <div class='col-sm-3 nopadding' style='padding-left: 15px'>
              <ejs-radiobutton :label='$t("MCS.cover")' name='areas' value='1'  :change='areasChange'></ejs-radiobutton>
            </div>
          </div>
        </div>
        <div class='h-col-inputBox'>
          <div class="h-inputLit">
            <ejs-button :isPrimary="true" @click.native="uploadFile">{{this.$t('System.selectFile')}}</ejs-button>
          </div>
          <div class="fl" v-show="fileShow">
            <input
              class="e-input"
              type="text"
              v-model="fileName"
              style="width:300px; float:left;"
              disabled='disabled'
            />
            <ejs-button ref="delTaskButton"
                        iconCss="icon hero-icon h-spectrum-icon hero-icon-remove"
                        cssClass="e-small e-round"
                        :isPrimary="true"
                        @click.native="deleteFile">
            </ejs-button>
          </div>
        </div>
      </div>
    </div>
    <div class="h-system-hide-upload">
      <ejs-uploader
        ref="importFile"
        name="importFile"
        id="importFile"
        :multiple="false"
        :autoUpload="false"
        :selected="onSelect"
      ></ejs-uploader>
    </div>
  </div>
</template>

<script>
  export default {
    name: "BatchManagementImport",
    data() {
      return {
        isShowBlackList: false,
        isShowRelations: true,
        isShowAreas: false,
        blacklistDealType: 0,
        relationsDealType: 0,
        areasDealType: 0,
        taskName: '',
        isCover: 1,
        isAppend: 0,
        importType: 3,
        importFile: null,
        dropElement: '.control-fluid',
        fileName: '',
        fileShow: false,
        listdata: [],
        fieldsOfImportType: {
          value: 'value',
          text: 'text'
        },
        dataSourceOfImportType: [
          {
            value: 1,
            text: this.$t('MCS.organizationImport')
          },
          {
            value: 2,
            text: this.$t('MCS.cellImport')
          },
          {
            value: 3,
            text: this.$t('MCS.userGroupMemberImport')
          },
          {
            value: 4,
            text: this.$t('MCS.blackImport')
          },
          {
            value: 5,
            text: this.$t('MCS.userAuthAreaImport')
          },
          {
            value: 6,
            text: this.$t('MCS.groupCallImport')
          }
        ]
      }
    },
    methods: {
      changeForImportType(msg){
        let aa = this.$refs.importType;
        console.log(aa);
        const selectImportType = msg.value;
        switch (selectImportType) {
          case 4:
            this.isShowBlackList = true;
            this.isShowRelations = false;
            this.isShowAreas = false;
            break;
          case 3:
            this.isShowRelations = true;
            this.isShowBlackList = false;
            this.isShowAreas = false;
            break;
          case 6:
            this.isShowAreas = true;
            this.isShowRelations = false;
            this.isShowBlackList = false;
            break;
          default:
            this.isShowAreas = false;
            this.isShowRelations = false;
            this.isShowBlackList = false;
            break;

        }
      },
      blackListChange(args) {
        this.blacklistDealType = args.value;
      },
      relationsChange(args) {
        this.relationsDealType = args.value;
      },
      areasChange(args) {
        this.areasDealType = args.value;
      },
      coverChange(args) {
        this.isCover = args.value;
      },
      _getNeTreeData() {
        this.listdata = [];
        this.$axios.post('/lte/ems/env/getEnvironmentList.html',{
          type: 'DP',
            page: {
            pageNo: 1,
              pageSize:200
          }
        }).then((response) => {
          const res = response.data.resultVal;
          const showData = [];
          if (response.status === 200 && res !== null) {
            res.result.forEach((_item) => {
              const { id, name} = _item;
              const _dataItem = {
                text: name,
                id: id
              };
              showData.push(_dataItem);
            });
          }
          this.listdata = showData;
        });
      },
      deleteFile(){
        this.fileShow = false;
        this.importFile = null;
        this.$refs.importFile.clearAll();
      },
      uploadFile() {
        document
          .getElementsByClassName('e-file-select-wrap')[0]
          .querySelector('button')
          .click();
        return false;
      },
      onSelect(args) {
        const file = args.filesData[0];
        this.fileName = '';
        this.fileName = file.name;
        console.log(`fileName=${this.fileName}`);
        this.importFile = null;
        this.importFile = file.rawFile;
        console.log(`importFile=${this.importFile}`);
        this.fileShow = true;
      }
    }
  }
</script>

<style>
  #chip-default-wrapper .sample-padding {
    padding: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .wrapper {
    display : table-cell;
    width : 600px;
    height : 30px;
    vertical-align: middle;
  }
</style>
